import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/pied-piper': {
    width: 480,
    height: 512,
    paths: [
      {
        d: 'M455.9 23.2c9.4-2.4 15.1 10.3 7 15.7-98.2 65.9-120.4 127.6-126.2 160.2-33.5 188.9-101.4 119.3-184.3 226.7 25.8 14.8 55.8 23.4 87.6 23.4 97.7 0 177.1-79.5 177.1-177.1 0-45.1-17-86.3-44.8-117.4 4.7-9.8 10.4-18.9 17-27.4 36.4 37.3 58.8 88.4 58.8 144.6v0.2c0 114.9-93.1 208-208 208s-208-93.1-208-208 93.1-208 208-208c36.7 0 71.5 9.8 101.3 26.7 46.4-39 87.9-60.7 114.6-67.5zM125 406.4c64.8-140.9 125.6-231.6 191.6-293.8-23.1-11.3-49.2-17.8-76.6-17.8h-0.1c-97.7 0-177.1 79.4-177.1 177.1 0 53.8 24.1 102 62.1 134.4z'
      }
    ]
  }
})
